import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(public ngZone: NgZone,private router: Router) { }

  reloadComponent() {
    this.ngZone.run(() => {
      let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([currentUrl]));
    });
  }

  deviceStatusOptions: string[] = [
    'New',
    'Provisioned',
    'Provisioning - Error',
    'Installed',
    'Installed - Error',
    'Installed - Incomplete',
    'Reset',
    'Deleted',
    'Uninstalled'
  ];
}
